"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateToQueryString = exports.queryStringMiddleware = exports.createQueryStringReducer = void 0;
var _qs = _interopRequireDefault(require("qs"));
var _merge = _interopRequireDefault(require("lodash/merge"));
var _get = _interopRequireDefault(require("lodash/get"));
var _set = _interopRequireDefault(require("lodash/set"));
var _validation = require("./validation");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var SERIALIZATION_OPTIONS = {
  allowDots: true,
  arrayFormat: 'repeat'
};
var _pruneNullLeaves2 = function _pruneNullLeaves(obj) {
  if (!Object.entries(obj).length) {
    return {};
  }
  return Object.assign.apply(Object, _toConsumableArray(Object.entries(obj).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      k = _ref2[0],
      v = _ref2[1];
    if (v === null) {
      return {};
    } else if (Array.isArray(v)) {
      return _defineProperty({}, k, v.filter(function (e) {
        return e !== null;
      }));
    } else if (_typeof(v) === 'object') {
      return _defineProperty({}, k, _pruneNullLeaves2(v));
    } else {
      return _defineProperty({}, k, v);
    }
  })));
};
var _applySerialization = function _applySerialization(stateData, map) {
  var result = {};
  Object.entries(map).forEach(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
      k = _ref7[0],
      stateField = _ref7[1].stateField;
    result[k] = typeof stateField === 'string' ? (0, _get["default"])(stateData, stateField, null) : stateField.serialize(stateData);
  });
  return result;
};
var stateToQueryString = exports.stateToQueryString = function stateToQueryString(state) {
  for (var _len = arguments.length, maps = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    maps[_key - 1] = arguments[_key];
  }
  var serializedState = Object.assign.apply(Object, _toConsumableArray(maps.map(function (map) {
    return _pruneNullLeaves2(_applySerialization(state, map));
  })));
  return _qs["default"].stringify(serializedState, SERIALIZATION_OPTIONS);
};
var queryStringMiddleware = exports.queryStringMiddleware = function queryStringMiddleware(history, _ref8) {
  var reduxPathname = _ref8.reduxPathname,
    routes = _ref8.routes;
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var usePush = config.usePush;
  return function (store) {
    return function (next) {
      return function (action) {
        var result = next(action);
        var state = store.getState();
        var currentPath = reduxPathname(state);
        var pathConfig = routes[currentPath];
        var routesConfig = pathConfig && !Array.isArray(pathConfig) ? [pathConfig] : pathConfig;
        if (routesConfig && routesConfig.length) {
          var prevData = _qs["default"].parse(history.location.search.slice(1), {
            allowDots: true
          });
          var dataList = routesConfig.filter(function (_ref9) {
            var listen = _ref9.listen;
            return Array.isArray(listen) ? listen.includes(action.type) : listen === action.type;
          }).map(function (_ref0) {
            var select = _ref0.select,
              serialize = _ref0.serialize;
            var qsState = select(state);
            var data = _pruneNullLeaves2(qsState);
            if (serialize) {
              data = _applySerialization(data, serialize);
            }
            return data;
          });
          if (dataList.length) {
            var data = Object.assign.apply(Object, _toConsumableArray(dataList));
            data = _pruneNullLeaves2(_objectSpread(_objectSpread({}, prevData), data));
            var queryString = _qs["default"].stringify(data, SERIALIZATION_OPTIONS);
            var path = "".concat(currentPath, "?").concat(queryString);
            if (usePush) {
              history.push(path);
            } else {
              history.replace(path);
            }
          }
        }
        return result;
      };
    };
  };
};
var createQueryStringReducer = exports.createQueryStringReducer = function createQueryStringReducer(config, qsFunc) {
  var resetFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (s) {
    return s;
  };
  return function (state, action) {
    var result = qsFunc(state, action);
    if (!result) {
      return resetFunc(state, null);
    }
    var queryString = result.queryString,
      namespace = result.namespace;
    if (queryString) {
      var values = _qs["default"].parse(queryString, {
        allowDots: true
      });
      var newValues = null;
      try {
        newValues = (0, _validation.mapQueryFields)(values, config);
        return (0, _merge["default"])({}, state, namespace ? (0, _set["default"])({}, namespace, newValues) : newValues);
      } catch (e) {
        console.warn(e);
        return resetFunc(state, namespace, true);
      }
    }
    return resetFunc(state, namespace);
  };
};